<template>
  <div>
    <v-flex
      xs12
      sm6
      md4>
      <v-label>{{ 'krita.reports.application.filter.labelcreated' | translate }}</v-label>
      <application-controllers
        :application-selection="applicationSelection"
        @filterApplications="filterApplications"
        @filterApplicationsDateFrom="filterApplicationsDateFrom"
        @filterApplicationsDateTo="filterApplicationsDateTo"
        @clearDate="clearDate"/>
    </v-flex>
    <v-card>
      <div class="text-xs-center pt-2">
        <search-text-field
          :search-phrase="applicationSearch"
          :row-count="applicationRowCount"
          @search="applicationSearchRefresh"
        />
        <application-datagrid
          :application-loading="applicationLoading"
          :application-report-data="applicationReportData"
          :rows-per-page="applicationRowsPerPage"
          :row-count="applicationRowCount"
          @refreshWithSort="refreshApplicationsWithSort"
        />
        <pagination
          :selected-page="applicationSelectedPage"
          :rows-per-page="applicationRowsPerPage"
          :row-count="applicationRowCount"
          @changeDisplayedRowCount="applicationChangeDisplayedRowCount"
          @clickedPage="changeApplicationPage"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import SearchTextField from '../../controllers/SearchTextField';
import Pagination from '../../controllers/Pagination.vue';
import ApplicationDatagrid from './ApplicationDatagrid';
import ApplicationControllers from './ApplicationControllers';
    export default {
        components: {Pagination, ApplicationDatagrid, ApplicationControllers,SearchTextField},
        props: ['selection'],
        data ()
        {
            return {
                applicationSelection: '',
                applicationSearch: '',

                applicationSelectedPage: 1,
                applicationRowsPerPage: 5,
                applicationRowCount: 0,
                applicationSorting:{},
                applicationReportData: [],
                applicationLoading: false,

                applicationsDateFrom: null,
                applicationsToDate: null,
            }
        },
        mounted ()
        {
            let self = this;

            self.setApplicationSelection();
            self.refreshApplicationReportData();
        },
        methods: {
            clearDate(target)
            {
                let self = this;

                switch (target) {
                    case 'fromDate':
                        self.applicationsDateFrom = null;
                        break;
                    case 'toDate':
                        self.applicationsToDate = null;
                        break;
                }
                self.refreshApplicationReportData();
            },
            setApplicationSelection ()
            {
                this.applicationSelection = this.selection;
            },
            changeApplicationPage (page)
            {
                let self = this;

                self.applicationSelectedPage = page;
                self.refreshApplicationReportData();
            },
            applicationChangeDisplayedRowCount (rowCount)
            {
              let self = this;

              self.applicationSelectedPage = 1;
              self.applicationRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
              self.refreshApplicationReportData();
            },
            filterApplications (selection)
            {
                this.applicationSelection = selection;
                this.refreshApplicationReportData();
            },
            filterApplicationsDateFrom(date)
            {
                let self = this;

                self.applicationsDateFrom = date;
                self.refreshApplicationReportData();
            },
            filterApplicationsDateTo(date)
            {
                let self = this;

                self.applicationsToDate = date;
                self.refreshApplicationReportData();
            },
            refreshApplicationsWithSort (pagination)
            {
                let self = this;

                self.applicationSorting = {};
                self.applicationSorting[pagination.sortBy] = pagination.descending ? 'desc' : 'asc';
                self.refreshApplicationReportData ();
            },
            applicationSearchRefresh (search)
            {
              let self = this;

              if (search !== '')
              {
                self.applicationSelectedPage = 1
              }
              self.applicationSearch = search;
              self.refreshApplicationReportData ();
            },
            refreshApplicationReportData ()
            {
                let self = this;
                self.applicationLoading = true;
                let applicationFetch = self.$store.dispatch('applications/getApplicationReport', {page: self.applicationSelectedPage, rowsPerPage: self.applicationRowsPerPage, from: self.applicationsDateFrom, to: self.applicationsToDate, selection: self.applicationSelection, sort: self.applicationSorting, search:self.applicationSearch });
                applicationFetch.then(response =>
                    {
                        self.processApplicationReport(response);
                        self.applicationLoading = false;
                    }, () =>
                    {
                        // error
                        self.applicationLoading = false;
                    }
                );
            },
            processApplicationReport (obj)
            {
                let self = this;

                let applicationReports = obj.Rows;
                self.applicationReportData = [];
                for (let applicationReport of applicationReports)
                {
                    let applicationReportClient = {
                        id: applicationReport.Id,
                        status: applicationReport.Status,
                        claimCount: applicationReport.ClaimCount,
                        capital: applicationReport.Capital,
                        initialTransferAmount: applicationReport.InitialTransferAmount,
                        created: applicationReport.Created
                    };
                    self.applicationReportData.push(applicationReportClient);
                }
                self.applicationRowCount = obj.TotalRowCount;
            },
        }
    }
</script>
